import axios from 'axios';
import { BASE_PATH, HOST_ORIGIN } from '../constants';

function updateState(uf, reload) {
  console.log('Update UF ->', window.state);

  reload = reload || false;

  axios.put(`${HOST_ORIGIN}/session/uf`, { uf: uf })
    .then((response) => {
      if (response.data.success) {
        // console.log('Geolocation UF ->', response.data.new_uf);
        // console.log('RELOAD >>>>>>>');

        // if (uf !== window.state) {
        //   if (reload) {
        //     window.location.reload(0);
        //   } else {
        //     window.location = '/';
        //   }
        // } else {
        //   let modalState = document.querySelector('.page-region');
        //   if (modalState) {
        //     modalState.style.opacity = 0;
        //     setTimeout(function () {
        //       modalState.remove();
        //       location.replace("/");
        //     }, 300);
        //   }
        // }
      } else {
        console.log('Geolocation Error ->', response.data.message);
      }
      window.location = '/';
    })
    .catch((error) => { 
      console.warn('updateState() Error', error); 
      window.location = '/';
    });

    
}

export default updateState;

document.addEventListener("DOMContentLoaded", function (evt) {
  function successLocation(position) {
    // console.log('Localstorage State : ', localStorage.getItem('cury_state'));
    // console.log('Window State : ', window.state);

    if (localStorage.getItem('cury_state')) return;

    const geoCoder = new google.maps.Geocoder();
    const coordinates = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

    geoCoder.geocode({ 'latLng': coordinates }, function (results, status) {
      if (status === google.maps.GeocoderStatus.OK) {
        const addressParts = getAddressParts(results[0]);
        const state = addressParts.administrative_area_level_1;

        console.warn('GeoCode State', status);

        // Update Local Storage Web Browser
        localStorage.setItem('cury_state', state);

        updateState(state);
      } else {
        console.warn('GeoCode failed', status);
      }
    });
  }

  function getAddressParts(obj) {
    const address = [];
    obj.address_components.map((el) => address[el.types[0]] = el.short_name);

    return address;
  }

  function errorLocation(error) {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        console.warn('User denied the request for Geolocation.');
        break;

      case error.POSITION_UNAVAILABLE:
        console.warn('Location information is unavailable.');
        break;

      case error.TIMEOUT:
        console.warn('The request to get user location timed out.');
        break;

      case error.UNKNOWN_ERROR:
        console.warn('An unknown error occurred.');
        break;
    }
  }

  // if ('geolocation' in navigator) {
  //     navigator.geolocation.getCurrentPosition(successLocation, errorLocation);
  // } else {
  //     console.warn('geolocation services are not supported by your browser.');
  // }
});
